import type { UserRoleEnum } from '@/modules/core/models/enums'

/** Objeto que contiene información sobre la contratación. Para rater */

export default class SaveQuotationHiring {
  /** (Integer): Número de la cotización, entero de 32 bits. */
  quotationNumber!: number | undefined

  /** (Integer): Forma de pago. */
  billingCycle!: string

  /** (Integer): Código del cliente. */
  clientCode!: number

  /** (Integer): Código del producto. */
  productCode!: number

  /** (String): Línea de negocio. */
  businessLine!: string

  /** (Datetime): Fecha de inicio del seguro. */
  insuranceStartDate!: string

  insuranceEndDate?: number | undefined

  /** (string): Rol del titular. */
  role?: UserRoleEnum | undefined

  constructor(data: any) {
    this.quotationNumber = data.quotationNumber
    this.billingCycle = data.billingCycle
    this.clientCode = data.clientCode
    this.productCode = data.productCode
    this.businessLine = data.businessLine
    this.insuranceStartDate = data.insuranceStartDate
    if (data.insuranceEndDate) this.insuranceEndDate = data.insuranceEndDate
    this.role = data.role
  }
}
